// generated by srcset-codegen
import src from "./onboarding1.png";

const width = 438;
const height = 300;
export default { src, width, height };
